import { axiosInstance } from "./globals";
import { RegionFilter } from "@/model/filters";
import { DataSourceRequest } from "@/model/DataSourceRequest";
import { DataSourceResult } from "@/model/DataSourceResult";
import { getAuthHeaders } from "@/service/userService";

export { getAuthHeaders };

/**
 * Lấy danh sách khu vực kinh doanh có phân trang và tìm kiếm theo tên
 * @param filter Bộ lọc tìm kiếm (tên, trang, số bản ghi/trang)
 */
export async function getRegionList(filter?: RegionFilter): Promise<any> {
  const keyword = filter?.q || filter?.name;
  const filters: any[] = keyword
    ? [{ field: "name", operator: "contains", value: keyword, logic: "or" }]
    : [];

  const body: DataSourceRequest = {
    page: filter?.page || 1,
    pageSize: filter?.pageSize || 1000,
    filters,
    sorts: [
      { field: "id", dir: "desc" }
    ]
  };

  try {
    const headers = getAuthHeaders();
    return (await axiosInstance.post<DataSourceResult<any>>("/Areas/GetAllAreas", body, { headers })).data;
  } catch (err) {
    console.log(err);
    return "";
  }
}

/**
 * Lấy danh sách chi nhánh đơn vị trực thuộc
 */
export async function getUnitAreaList() {
  try {
    const headers = getAuthHeaders();
    return (await axiosInstance.get("/Customer/GetOrganizationBranch?searchKey=VNPT000000", { headers })).data;
  } catch (err) {
    console.log(err);
    return "";
  }
}

/**
 * Lấy toàn bộ danh mục tỉnh/thành phố hiện tại
 */
export async function getAllAreaList() {
  try {
    const headers = getAuthHeaders();
    return (await axiosInstance.get("/provinces/getAllCurrent", { headers })).data;
  } catch (err) {
    console.log(err);
    return "";
  }
}

/**
 * Lấy thông tin chi tiết khu vực theo ID.
 * Luồng xử lý:
 * 1. Gọi /Areas/GetById/{id}?includeSubscriptions=true. Nếu có sẵn subscriptions -> trả về ngay.
 * 2. Trường hợp API GetById không trả về chi tiết gói cước mà chỉ có ID, tự động fallback truy vấn
 *    /Areas/GetAllAreas lọc theo ID để lấy đầy đủ đối tượng subscriptions, tránh màn hình bị trống gói cước.
 * @param id ID của khu vực cần lấy thông tin
 */
export async function getRegionDetail(id: number) {
  const headers = getAuthHeaders();

  try {
    // Bước 1: Thử lấy chi tiết trực tiếp qua endpoint GetById
    const res = (await axiosInstance.get("/Areas/GetById/" + id + "?includeSubscriptions=true", { headers })).data;
    const region = res?.data || res;
    const subs = region?.subscriptions || region?.subscriptionPlans || region?.subcriptions || region?.subcriptionPlans;
    if (subs && subs.length > 0) {
      return res;
    }

    // Bước 2: Fallback lấy thông tin gói cước đầy đủ từ GetAllAreas lọc theo id
    const body: DataSourceRequest = {
      page: 1,
      pageSize: 100,
      filters: [{ field: "id", operator: "eq", value: id }],
      sorts: [{ field: "id", dir: "desc" }]
    };
    const allAreasRes = (await axiosInstance.post<DataSourceResult<any>>("/Areas/GetAllAreas", body, { headers })).data;
    const allAreas = allAreasRes?.data || allAreasRes;
    if (Array.isArray(allAreas)) {
      const matched = allAreas.find((a: any) => a.id === id);
      if (matched && matched.subscriptions && matched.subscriptions.length > 0) {
        if (res && res.data) {
          res.data.subscriptions = matched.subscriptions;
          return res;
        }
        return { data: matched };
      }
    }
    return res;
  } catch (e) {
    // Trường hợp lỗi API GetById, fallback trực tiếp qua GetAllAreas
    const body: DataSourceRequest = {
      page: 1,
      pageSize: 100,
      filters: [{ field: "id", operator: "eq", value: id }],
      sorts: [{ field: "id", dir: "desc" }]
    };
    const allAreasRes = (await axiosInstance.post<DataSourceResult<any>>("/Areas/GetAllAreas", body, { headers })).data;
    const allAreas = allAreasRes?.data || allAreasRes;
    if (Array.isArray(allAreas)) {
      const matched = allAreas.find((a: any) => a.id === id);
      if (matched) {
        return { data: matched };
      }
    }
    throw e;
  }
}
